import React from "react";
import { TextField } from "@mui/material";

interface FormatArrayProps {
  subIndex: string;
  keyName: string;
  value: any;
  isEditing: boolean;
  inputs: Record<string, string>;
  onChange: (fieldKey: string, newValue: string) => void;
}

const PatientFormatArray: React.FC<FormatArrayProps> = ({
  subIndex,
  keyName,
  value,
  isEditing,
  inputs,
  onChange,
}) => {
  const isInvalidString = (val: unknown): boolean =>
    typeof val === "string" && ["na", "n.a"].includes(val.toLowerCase());

  if (
    !value ||
    isInvalidString(value) ||
    (Array.isArray(value) && value.length === 0)
  ) {
    const inputKey = `${subIndex}`;
    return (
      <li key={subIndex}>
        <strong>{keyName}:</strong>{" "}
        {isEditing ? (
          <TextField
            variant="standard"
            value={inputs[inputKey] || ""}
            onChange={(e) => onChange(inputKey, e.target.value)}
            size="small"
            fullWidth
          />
        ) : null}
      </li>
    );
  }

  if (Array.isArray(value)) {
    return (
      <li key={subIndex}>
        <strong>{keyName}:</strong>{" "}
        {value.map((item: string, index: number) => {
          const inputKey = `${subIndex}_${index}`;
          return isEditing ? (
            <div key={inputKey} style={{ paddingLeft: index > 0 ? "2em" : 0 }}>
              <TextField
                variant="standard"
                value={inputs[inputKey] ?? item}
                onChange={(e) => onChange(inputKey, e.target.value)}
                size="small"
                fullWidth
              />
            </div>
          ) : (
            <React.Fragment key={index}>
              {index === 0 ? (
                item
              ) : (
                <span style={{ display: "block", paddingLeft: "2em" }}>
                  {item}
                </span>
              )}
            </React.Fragment>
          );
        })}
      </li>
    );
  }

  if (typeof value === "object") {
    return (
      <li key={subIndex}>
        <strong>{keyName}:</strong>
        <ul>
          {Object.entries(value).map(([subkey, subvalue], index) => {
            const inputKey = `${subIndex}_${subkey}`;
            return (
              <li key={index}>
                <strong>{subkey}:</strong>{" "}
                {isEditing ? (
                  <TextField
                    variant="standard"
                    value={inputs[inputKey] ?? subvalue}
                    onChange={(e) => onChange(inputKey, e.target.value)}
                    size="small"
                  />
                ) : Array.isArray(subvalue) ? (
                  subvalue.join(", ")
                ) : (
                  String(subvalue)
                )}
              </li>
            );
          })}
        </ul>
      </li>
    );
  }

  const inputKey = `${subIndex}`;
  return (
    <li key={subIndex}>
      <strong>{keyName}:</strong>{" "}
      {isEditing ? (
        <TextField
          variant="standard"
          value={inputs[inputKey] ?? value}
          onChange={(e) => onChange(inputKey, e.target.value)}
          size="small"
        />
      ) : (
        value
      )}
    </li>
  );
};

export default PatientFormatArray;
